import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ficha-representante',
  templateUrl: './ficha-representante.component.html',
  styleUrls: ['./ficha-representante.component.scss']
})
export class FichaRepresentanteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
